import {
  Card,
  CardContent,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { useState } from "react";

function SelectNetwork(props) {
  const [network, setNetwork] = useState(60);

  const handleChange = (event, newNetwork) => {
    if (newNetwork !== null) {
      setNetwork(newNetwork);
      props.setNetwork(newNetwork);
    }
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          3. Select Network
        </Typography>
        <ToggleButtonGroup
          value={network}
          exclusive
          onChange={handleChange}
          aria-label="network"
        >
          {Object.entries({ BTC: 0, ETH: 60, XRP: 144 }).map(
            ([networkName, value]) => (
              <ToggleButton
                key={networkName}
                value={value}
                aria-label={networkName}
                disabled={value !== 60}
              >
                {networkName}
              </ToggleButton>
            )
          )}
        </ToggleButtonGroup>
      </CardContent>
    </Card>
  );
}

export default SelectNetwork;
